// LanguageContext.js

import React from "react";

// Create the language context
const LanguageContext = React.createContext();

export default LanguageContext;
